import { render, staticRenderFns } from "./CelularData.vue?vue&type=template&id=c6f5afe6&"
import script from "./CelularData.vue?vue&type=script&lang=js&"
export * from "./CelularData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports